import React, { useContext } from 'react';
import { Button } from 'components';
import { LocalContext, FirebaseContext } from 'context';
import { clearQueryParams } from 'utils';
import styled, { css } from 'styled-components';
import { FormContainer } from '../FormComponents';

const RecoverEmail = ({ emailRecovered, setShowRecoverEmailModal, userEmail }) => {
  const { theme } = useContext(LocalContext);
  const { firebase } = useContext(FirebaseContext);
  return (
    <FormContainer theme={theme}>
      <Status
        emailRecovered={emailRecovered}
        dangerouslySetInnerHTML={{
          __html: emailRecovered
            ? `Account successfully reverted to:<br />${userEmail}<br /><br />`
            : 'Loading'
        }}
      />
      <Button
        onClick={() => {
          clearQueryParams();
          setShowRecoverEmailModal(false);
          firebase.logout();
        }}
        type="button"
        width="9.25rem"
        whileTap={{ scale: 0.9 }}
        style={{
          margin: '0 auto'
        }}>
        Close
      </Button>
    </FormContainer>
  );
};

const Status = styled.h3`
  align-items: center;
  display: flex;

  font-size: 1.5rem;
  font-style: normal;
  font-weight: 700;
  justify-content: center;
  line-height: 1.75rem;
  text-align: center;

  ${({ emailRecovered }) =>
    !emailRecovered &&
    css`
      &:after {
        animation: dots 1s steps(5, end) infinite;
        content: ' .';
        margin-left: 0.25rem;
      }

      @keyframes dots {
        0%,
        20% {
          color: rgba(0, 0, 0, 0);
          text-shadow: 0.5rem 0 0 rgba(0, 0, 0, 0), 1rem 0 0 rgba(0, 0, 0, 0);
        }
        40% {
          color: #fff;
          text-shadow: 0.5rem 0 0 rgba(0, 0, 0, 0), 1rem 0 0 rgba(0, 0, 0, 0);
        }
        60% {
          text-shadow: 0.5rem 0 0 #fff, 1rem 0 0 rgba(0, 0, 0, 0);
        }
        80%,
        100% {
          text-shadow: 0.5rem 0 0 #fff, 1rem 0 0 #fff;
        }
      }
    `}
`;

export default RecoverEmail;
